import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import T from '../../../i18n/i18n';
import { Container, ButtonRow, Label, Input, Select, Row } from './TurnOrderForm.styles';
import { Button } from '../../../../styles/globalComponents';

export default ({className, value, onClickSave, onClickBack}) => {

    const [formName, setFormName] = useState(value ? (value.name || '') : '');
    const [formValue, setFormValue] = useState(value ? (value.value || '') : '');
    const [formToken, setFormToken] = useState(value ? (value.token || '') : '');
    
    const characterList = useSelector(state => state.charactersState.characters);

    useEffect(() => {
        if (value) {
            setFormName(value.name || '');
            setFormValue(value.value || '');
            setFormToken(value.token || '');
        } else {
            setFormName('');
            setFormValue('');
            setFormToken('');
        }
    }, [value]);

    const handleSave = () => {
        if (typeof onClickSave === 'function') {
            onClickSave({
                name: formName,
                value: formValue,
                token: formToken
            }, value);

            setFormName('');
            setFormValue('');
            setFormToken('');
        }
    };

    const handleBack = () => {
        handleClear();
        if (typeof onClickBack === 'function') {
            onClickBack()
        }
    };

    const handleClear = () => {
        setFormName('');
        setFormValue('');
        setFormToken('');
    }

    return <Container className={className ? className : ""}>
        <Label><T value="turnorder.name" /></Label>
        <Input value={formName} onChange={(e)=>{setFormName(e.target.value)}}/>
        <Row>
            <Label><T value="turnorder.token" /></Label>
            <Label><T value="turnorder.value" /></Label>
        </Row>
        <Row>
            <Select value={formToken} onChange={(e)=>{setFormToken(e.target.value)}}>
                <option value=""></option>
                {characterList.map(char => <option key={char.id} value={char.id}>{char.name}</option>)}
            </Select>
            <Input value={formValue} onChange={(e)=>{setFormValue(e.target.value)}}/>
        </Row>
        <ButtonRow>
            <Button color="#0c0" onClick={handleSave}><T value="turnorder.save" /></Button>
            <Button color="#f33" onClick={handleBack}><T value="turnorder.back" /></Button>
        </ButtonRow>
    </Container>
}